import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "PhP conference",
  "description": "",
  "published": "2008-07-07T00:00:00.000Z",
  "redirect_from": ["/blog/php-conference/swizec/97"],
  "categories": "life, review",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`This saturday the first ever `}<a parentName="p" {...{
        "href": "http://phpkonferenca.si/"
      }}>{`php conference in slovenia`}</a>{` happened ... and it was fun. I've never been to such an event before so there isn't really much I can compare it to, but I can compare to `}<a parentName="p" {...{
        "href": "http://swizec.com/index.php/mode=news/id=330"
      }}>{`Blogres`}</a>{` . And you know what, blogres may have been a tad bigger and it may have had a fancier location and more famous speakers, but by god was it much more boring and seemingly poorer organised.`}</p>
    <p>{`Now it may just be that I found these talks more interesting because they were about the things I do for a living and practically devote my life to, or it may just be that when the room is packed to the brim with people it all seems more fun than when it's half empty. What I really liked about the php conference was that there was food, real food, for free.`}</p>
    <p>{`What I loved even more was just how much food there was. For example there were croissants at every coffee break and for lunch PIZZA, and developers love pizza ... Well anyway, let's hope there's more such events in the near future.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      